import { Stack, StackProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { FC } from 'react';
interface ContentContainerProps extends StackProps {
  children: ReactNode;
}
const ContentContainer: FC<ContentContainerProps> = ({ children, ...props }) => {
  return (
    <Stack maxW={'1440px'} {...props} px={{ base: 4, sm: 0 }}>
      {children}
    </Stack>
  );
};
export default ContentContainer;
